import { DialogProps } from "@mui/material";

export type DialogCloseReason = "backdropClick" | "escapeKeyDown";

/**
 * Build a Dialog/Modal `onClose` handler that ignores the given close reasons.
 *
 * MUI v9 removed the `disableEscapeKeyDown` prop — instead MUI always calls `onClose`
 * with the `reason` and leaves it to the caller to decide. This drops the close for any
 * ignored reason and calls `handler()` for the rest.
 */
export const onCloseExcept =
    (ignore: DialogCloseReason[], handler: () => void): NonNullable<DialogProps["onClose"]> =>
    (_event, reason) => {
        if (!ignore.includes(reason)) {
            handler();
        }
    };

/** Convenience for the dominant case: close on anything except the Escape key. */
export const onCloseUnlessEscape = (handler: () => void): NonNullable<DialogProps["onClose"]> => onCloseExcept(["escapeKeyDown"], handler);
